import { format } from 'date-fns';
import { ViewModelService } from 'src/app/shared/view-model.service';
import { TripLegViewModel } from 'src/models/trip-leg-view-model';
import { TripPassengerViewModel } from 'src/models/trip-passenger-view-model';
import {
  ManifestEntryRecord,
  ManifestEntryViewModelBase,
} from 'src/store/generated/manifest-entry-record.generated';

export class ManifestEntryViewModel extends ManifestEntryViewModelBase {
  public readonly tripLeg: TripLegViewModel;
  public readonly passenger: TripPassengerViewModel;

  get isConfirmed() {
    return this.confirmedAt != null;
  }

  get confirmedAtDisplay() {
    return this.confirmedAt != null ? format(this.confirmedAt, 'MM/dd/yyyy HH:mm:ss') : null;
  }
  constructor(
    entry: ManifestEntryRecord,
    tripLeg: TripLegViewModel,
    passenger: TripPassengerViewModel,
    private readonly _model: ViewModelService,
  ) {
    super(entry);
    this.tripLeg = tripLeg;
    this.passenger = passenger;
  }
}
